import { LabelOptions } from 'chartjs-plugin-datalabels/types/options';

export class ChartHandler {
  public static labelConfig(visible = true): LabelOptions {
    return {
      display: visible,
      color: '#2E2E38 ', // Color of the data labels
      anchor: 'end', // Position of the labels: start, center, end
      align: 'top',
      backgroundColor: '#EAEAF2',
      borderColor: '#2E2E38 ',
      borderRadius: 20,
      borderWidth: 1,
      font: {
        size: 16,
      },
      padding: {
        top: 2,
        bottom: 2,
        left: 8,
        right: 8,
      },
    };
  }

  public static generateLegend(id, scrollChart, fixedChart, isTop = false, isRight = false) {
    // const chartBox = document.querySelector('.scrollArea');
    const fixedChartEl = document.getElementById(id + 'fixedChart');

    // const chartBox = document.getElementById(id + 'chart-box');
    const chartBox = fixedChartEl.parentNode.parentNode.parentNode;

    //remove existing if present
    const tempDiv = document.getElementById(id + 'custom-legend');
    tempDiv ? chartBox.removeChild(tempDiv) : '';

    const div = document.createElement('DIV');
    div.setAttribute('id', id + 'custom-legend');

    div.style.cssText = `
    position:absolute;
    padding:0.2em 1rem;
    ${isTop ? 'top:0' : 'bottom:0'};
    ${isRight ? 'right:0' : 'left:0'};
    light:0;
    `;

    const ul = document.createElement('UL');
    ul.style.cssText = `display: flex;
    margin: 0;
    padding: 0;
    column-gap: 1rem;`;
    const legendtext = [];
    scrollChart.legend.legendItems.forEach((dataset, index) => {
      if (legendtext.includes(dataset.text)) {
        return;
      }

      legendtext.push(dataset.text);
      const li = document.createElement('LI');

      li.style.cssText = `
      display: flex;
      align-items: center;
      cursor: pointer;
      margin-bottom: 5px;
      line-height: normal;
      font-family: $primary-font !important;
      font-size:13px;`;
      const spanBox = document.createElement('SPAN');
      spanBox.style.cssText = `
      display: inline-block;
      height: 20px;
      width: 20px;

      margin-right: 10px;
      border-style: solid;
      border-width: 2.5px;`;

      spanBox.style.borderColor = dataset.fillStyle;
      spanBox.style.backgroundColor = dataset.fillStyle;

      if (dataset.pointStyle == 'circle') {
        spanBox.style.borderRadius = '50%';
        spanBox.style.textDecoration = 'line-through';
        spanBox.style.borderColor = dataset.strokeStyle;
      }

      const p = document.createElement('P');
      p.style.color = dataset.fontColor;
      p.style.padding = '0';
      p.style.margin = '0';

      const textNode = document.createTextNode(dataset.text);

      li.onclick = (event) => {
        // fixed chart change
        let isHidden = !fixedChart.isDatasetVisible(dataset.datasetIndex);
        fixedChart.setDatasetVisibility(dataset.datasetIndex, isHidden);

        fixedChart.update();

        //scroll chart change
        isHidden = !scrollChart.isDatasetVisible(dataset.datasetIndex);
        scrollChart.setDatasetVisibility(dataset.datasetIndex, isHidden);

        const element = event.target['parentNode'];
        element.classList.toggle('marker');
        // if (element.classList.contains('marker') ) {
        if (!isHidden) {
          p.style.textDecoration = 'line-through';
          p.style.fontWeight = 'lighter';
        } else {
          p.style.textDecoration = 'none';
          p.style.fontWeight = 'lighter';
        }
        scrollChart.update();
      };

      ul.appendChild(li);
      li.appendChild(spanBox);
      li.appendChild(p);

      p.appendChild(textNode);
    });

    // chartBox.insertBefore(div, chartBox.childNodes[0]);  //to show legend in top
    chartBox.append(div); //to show legend in bottom
    div.appendChild(ul);
  }
}
